<template>
  <div>
    <section class="section-container-color">
      <div class="">
        <img
          src="/assets/images/examen-eod.png"
          alt="Escuela de Observadores Democráticos"
          class="header-banner-img"
        />
      </div>
      <div class="container section-container-title">
        <div class="row justify-content-center mb-3">
          <div class="col-12 col-lg-10 col-xl-8 text-center">
            <h3 class="text-transparencia font-weight-700 mb-2">
              Examen para la Obtención de la Constancia de Capacitación en Observación Electoral 2026
            </h3>
          </div>
        </div>

        <div class="row justify-content-center mb-2">
          <div class="col-12 col-lg-10 col-xl-8">
            <div class="card shadow-3 rounded-box border-0">
              <div class="card-body p-4 p-md-4">
                <h5 class="text-transparencia font-weight-700 mb-2">
                  ¿Qué es este examen?
                </h5>

                <p class="mb-2">
                  Este examen forma parte del proceso de capacitación de la Escuela de Observadores
                  Democráticos. Su propósito es evaluar los conocimientos adquiridos y confirmar que
                  cuentas con la preparación necesaria para participar en las actividades de observación electoral.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="row justify-content-center">
          <div class="col-12 col-lg-10 col-xl-8">
            <div class="card shadow-3 rounded-box mb-5">
              <div class="card-body p-4 p-md-5">
                <form id="frmRegistroExamen" @submit.prevent="comenzarExamen" novalidate>
                  <h5 class="text-transparencia font-weight-700 mb-2">
                    Formulario de Registro
                  </h5>
                  <div class="form-group">
                    <label class="font-weight-600">Nombres y Apellidos</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model.trim="model.nombresApellidos"
                      required
                      data-parsley-required-message="Ingresa tus nombres y apellidos"
                      data-parsley-max-caracteres-nombre="200"
                      data-parsley-trigger="keyup"
                    />
                  </div>

                  <div class="form-group">
                    <label class="font-weight-600">Correo Electrónico</label>
                    <input
                      type="email"
                      class="form-control"
                      v-model.trim="model.correo"
                      required
                      data-parsley-required-message="Ingresa tu correo"
                      data-parsley-email-advanced
                      data-parsley-trigger="change"
                    />
                  </div>

                  <div class="form-group">
                    <label class="font-weight-600">Número de contacto</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model.trim="model.telefono"
                      required
                      data-parsley-required-message="Ingresa tu número de contacto"
                      data-parsley-celular-generico
                      data-parsley-trigger="keyup"
                    />
                  </div>

                  <div class="form-group">
                    <label class="font-weight-600">DNI</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model.trim="model.dni"
                      required
                      data-parsley-required-message="Ingresa tu DNI"
                      data-parsley-dni
                      data-parsley-trigger="keyup"
                    />
                  </div>

                  <div class="form-group">
                      <div class="form-group">
                          <label class="font-weight-600">Región donde resides </label>
                          <select class="form-control" v-model="model.regionId" @change="onRegionChange" required data-parsley-required-message="Selecciona la región donde resides">
                              <option :value="null">Seleccione...</option>
                              <option :value="-1">Soy extranjero/a</option>
                              <option v-for="item in regiones" :key="item.id" :value="item.id">
                                  {{ item.text }}
                              </option>
                          </select>
                      </div>

                      <div class="form-group" v-if="model.regionId === -1">
                          <label class="font-weight-600">País / ciudad donde resides</label>
                          <input type="text" class="form-control" v-model="model.regionExtranjeroTexto" maxlength="50" required data-parsley-required-message="Indica tu lugar de residencia" data-parsley-maxlength="50" data-parsley-maxlength-message="Máximo 50 caracteres" />
                      </div>
                  </div>

                  <div class="form-row" v-if="model.regionId !== -1">
                    <div class="form-group col-12 col-md-6">
                      <label class="font-weight-600">Provincia</label>
                      <select
                          class="form-control"
                          v-model="model.provinciaId"
                          @change="onProvinciaChange"
                          :disabled="!model.regionId || model.regionId === -1 || !provincias.length"
                          :required="model.regionId !== -1"
                          :data-parsley-required="model.regionId !== -1"
                          data-parsley-required-message="Selecciona tu provincia"
                          data-parsley-trigger="change"
                        >
                        <option :value="null">Seleccione...</option>
                        <option v-for="item in provincias" :key="item.id" :value="item.id">
                          {{ item.text }}
                        </option>
                      </select>
                    </div>

                    <div class="form-group col-12 col-md-6" v-if="model.regionId !== -1">
                      <label class="font-weight-600">Distrito</label>
                      <select
                        class="form-control"
                        v-model="model.distritoId"
                        :disabled="!model.provinciaId || model.regionId === -1 || !distritos.length"
                        :required="model.regionId !== -1"
                        :data-parsley-required="model.regionId !== -1"
                        data-parsley-required-message="Selecciona tu distrito"
                        data-parsley-trigger="change"
                      >
                        <option :value="null">Seleccione...</option>
                        <option v-for="item in distritos" :key="item.id" :value="item.id">
                          {{ item.text }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="indicaciones-box p-3 rounded">
                    <h6 class="font-weight-600 mb-2">Indicaciones</h6>
                    <ul class="mb-0 pl-3">
                      <li>El examen consta de <strong>20 preguntas</strong> de opción múltiple.</li>
                      <li>Se requiere un mínimo de 11 respuestas correctas para aprobar.</li>
                      <li>Cada pregunta tiene un tiempo máximo de <strong>2 minutos</strong>.</li>
                      <li>No es posible retroceder a preguntas anteriores.</li>
                      <li>No actualice ni cierre la página durante el examen, ya que perderá su progreso.</li>
                      <li>Verifica que tus nombres y apellidos estén correctamente escritos.</li>
                      <li>Al finalizar, se mostrará el resultado. En caso de aprobar, podrá descargar su constancia de capacitación.</li>
                    </ul>
                  </div>

                  <div class="text-center mt-4">
                    <button type="submit" class="btn btn-transparencia btn-round px-4">
                      <i class="fas fa-play fa-fw mr-1"></i> Comenzar examen
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
  </div>
</template>

<script>
import $ from "jquery";
import "parsleyjs";
import Swal from "sweetalert2";

export default {
  name: "registro-examen",
  metaInfo: { title: "Examen" },
  data: () => ({
    model: {
      nombresApellidos: "",
      correo: "",
      telefono: "",
      dni: "",
      regionId: null,
      provinciaId: null,
      distritoId: null,
      regionExtranjeroTexto: "",
    },
    regiones: [],
    provincias: [],
    distritos: [],
  }),
  methods: {
    fetchDataInit() {
      this.$http.get(this.apiRoute("Common", "ListRegion")).then((response) => {
        if (!response.body.error) this.regiones = response.body.data || [];
      });
    },
    onRegionChange() {
      this.model.provinciaId = null;
      this.model.distritoId = null;
      this.provincias = [];
      this.distritos = [];
      if (this.model.regionId == null) {
        this.model.regionExtranjeroTexto = "";
        this.$nextTick(() => $("#frmRegistroExamen").parsley().reset());
        return;
      }
      if (this.model.regionId === -1) {
        this.$nextTick(() => $("#frmRegistroExamen").parsley().reset());
        return;
      }

      const params = { regionId: this.model.regionId };
      this.$http.get(this.apiRoute("Common", "ListProvincias"), { params }).then((response) => {
        if (!response.body.error) this.provincias = response.body.data || [];
      });

      this.$nextTick(() => $("#frmRegistroExamen").parsley().reset());
    },
    onProvinciaChange() {
      this.model.distritoId = null;
      this.distritos = [];
      if (!this.model.provinciaId) return;

      const params = { provinciaId: this.model.provinciaId };
      this.$http.get(this.apiRoute("Common", "ListDistritos"), { params }).then((response) => {
        if (!response.body.error) this.distritos = response.body.data || [];
      });

      this.$nextTick(() => $("#frmRegistroExamen").parsley().reset());
    },
    comenzarExamen() {
      const $form = $("#frmRegistroExamen");
      if (!$form.parsley().validate()) return;

      Swal.fire({
        title: "¿Confirmas que tus datos son correctos?",
        text: "Si continúas, iniciarás el examen.",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Sí, comenzar",
        cancelButtonText: "Revisar",
        reverseButtons: true,
      }).then((result) => {
        if (!result.isConfirmed) return;

        const regionObj = this.regiones.find(r => r.id === this.model.regionId);
        const provinciaObj = this.provincias.find(p => p.id === this.model.provinciaId);
        const distritoObj = this.distritos.find(d => d.id === this.model.distritoId);

        const payload = {
          nombresApellidos: this.model.nombresApellidos,
          correo: this.model.correo,
          telefono: this.model.telefono,
          dni: this.model.dni,
          region: this.model.regionId === -1 ? "" : (regionObj?.text || ""),
          provincia: this.model.regionId === -1 ? "" : (provinciaObj?.text || ""),
          distrito: this.model.regionId === -1 ? "" : (distritoObj?.text || ""),
          regionExtranjero: this.model.regionId === -1 ? (this.model.regionExtranjeroTexto || "").trim() : "",
        };

        sessionStorage.setItem("eod_exam_registro", JSON.stringify(payload));
        this.$router.push("/voluntariado/escuela-observadores-democraticos/examen");
      });
    },
    initParsley() {
    if (!window.Parsley) return;

    window.Parsley.addMessages("es", {
        defaultMessage: "Este valor parece ser inválido.",
        type: {
        email: "Este valor debe ser un correo válido.",
        url: "Este valor debe ser una URL válida.",
        number: "Este valor debe ser un número válido.",
        integer: "Este valor debe ser un número válido.",
        digits: "Este valor debe ser un dígito válido.",
        alphanum: "Este valor debe ser alfanumérico.",
        },
        notblank: "Este valor no debe estar en blanco.",
        required: "Este valor es requerido.",
        pattern: "Este valor es incorrecto.",
        min: "Este valor no debe ser menor que %s.",
        max: "Este valor no debe ser mayor que %s.",
        range: "Este valor debe estar entre %s y %s.",
        minlength: "Este valor es muy corto. La longitud mínima es de %s caracteres.",
        maxlength: "Este valor es muy largo. La longitud máxima es de %s caracteres.",
        length: "La longitud de este valor debe estar entre %s y %s caracteres.",
        mincheck: "Debe seleccionar al menos %s opciones.",
        maxcheck: "Debe seleccionar %s opciones o menos.",
        check: "Debe seleccionar entre %s y %s opciones.",
        equalto: "Este valor debe ser idéntico.",
    });

    window.Parsley.setLocale("es");

    if (!window.__eod_parsley_validators__) {
        window.Parsley.addValidator("emailAdvanced", {
        requirementType: "string",
        validateString: function (value) {
            return /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/.test(value);
        },
        messages: { es: "Ingresa un correo electrónico válido." },
        });

        window.Parsley.addValidator("dni", {
        requirementType: "string",
        validateString: function (value) {
            return /^[0-9]{8}$/.test(value);
        },
        messages: { es: "Ingresa un DNI válido (8 dígitos)." },
        });

        window.Parsley.addValidator("celularGenerico", {
        requirementType: "string",
        validateString: function (value) {
            return /^[0-9]{7,20}$/.test((value || "").trim());
        },
        messages: { es: "Ingresa un número válido (solo números, 7 a 20 dígitos)." },
        });

        window.Parsley.addValidator("maxCaracteresNombre", {
        requirementType: "number",
        validateString: function (value, max) {
            return (value || "").length <= max;
        },
        messages: { es: "El texto no puede exceder los 200 caracteres." },
        });

        window.__eod_parsley_validators__ = true;
    }

    this.$nextTick(() => {
        const $form = $("#frmRegistroExamen");
        if ($form.length) {
        $form.parsley().destroy();
        $form.parsley();
        }
    });
    }
  },
  mounted() {
    this.initParsley();
    this.fetchDataInit();
  },
};
</script>
<style scoped>
.header-banner-img {
  width: 100%;
  height: 180px;
  object-fit: center;
  object-position: center;
  display: block;
  border-radius: 0px 0px 24px 24px;
}

.indicaciones-box {
  background-color: #f4f8fb;
  border-left: 4px solid #009fe3;
}
</style>
